export const ERROR_PATHS = {
  AccessDenied: 'access-denied',
  Error: 'error',
  NotFound: 'not-found',
  TokenError: 'token-error'
};
